import { callPostApi } from "../callApi"
import urls from "../urls"

const userService = {

    authenticateUser : (data : {
        token : string
    })=>{
         return callPostApi(urls.USER_LOGIN, data)
    }
}

export default userService